export const ANALYSIS_ATOM_KEYS = {
  STORE_AIRBRIDGE: 'airbridge',
  STORE_MARKETING_GTM: 'marketingGTM',
} as const
